import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '../../core/translation';

@Component({
  selector: 'app-log-in-route',
  templateUrl: './log-in-route.component.html',
  styleUrls: ['./log-in-route.component.scss']
})
export class LogInRouteComponent implements OnInit {

  redirect: boolean = false;
  @Input() route: number;


  constructor(
    public _router: Router,
    public _traslate: TranslateService) {
   }

  ngOnInit(): void {
    const urlActual = window.location.href;
    if(!urlActual.includes('finishOperation')) {
      this.redirect = true
    }
  }

  routeLogIn(){
    this.redirect = true;
    localStorage.setItem('pending_logIn', JSON.stringify(this.route));
    this._router.navigate(['/login']);
  }

}
